import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackAddToWishListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/wishList/trackAddToWishList";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackAddToWishList = (
    parameters: PartialSpecific<TrackAddToWishListParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventListTrackerHook(ga.track.addToWishList, parameters, options);
};

export default useTrackAddToWishList;
